module.exports = __webpack_public_path__ + "img/pot@3x.e6eee54.png";